(() => {
  "use strict";

  const selector = "[data-nfd-back-in-stock]";

  const syncAvailability = (variant) => {
    document.querySelectorAll(selector).forEach((container) => {
      container.hidden = !variant || variant.available !== false;

      if (variant?.id) {
        container.dataset.variantId = String(variant.id);
      } else {
        delete container.dataset.variantId;
      }
    });
  };

  document.addEventListener("variant:change", (event) => {
    syncAvailability(event.detail?.variant);
  });
})();
